<app-dc-header class="headerContainer">
  <ng-container class="heading">PDF Diff: {{ title }} </ng-container>
  <ng-container class="actions">
    <button class="btn-sm btn-dark" (click)="closeTab()">Close</button>
  </ng-container>
</app-dc-header>
<app-dc-pane
  class="detailsContainer"
  noPadding="true"
  noScrollBar="true"
  noHeader="true"
  [loading]="loading"
>
  <div *ngIf="!loading && viewerUrl" class="cover"></div>
  <iframe
    [src]="viewerUrl"
    style="height: 100%; width: 100%; border: 1px solid #e0e0e0"
    allowfullscreen
  ></iframe>
</app-dc-pane>
